import _scrollbarSize from 'dom-helpers/scrollbarSize';

export const scrollbarSize = (...args) => _scrollbarSize(...args) || 16;
